import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { LoginService } from "../services/login.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthRegisterResponse } from "../models/auth-register-response.model";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): Observable<boolean> {
    const { token, refreshToken } = this.loginService.getStorageAccessToken();

    if (this.loginService.checkToken(token)) {
      return of(true);
    } else if (this.loginService.checkToken(refreshToken)) {
      return this.loginService.refresh(refreshToken).pipe(
        map((res:AuthRegisterResponse) => {
          this.loginService.setStorageAccessToken(res.token, res.ref_token);
          return true;
        }),
        catchError(() => {
          this.router.navigate(['/login']);
          return of(false);
        })
      );
    } else {
      this.router.navigate(['/login']);
      return of(false);
    }
  }
}